import { render, staticRenderFns } from "./ActorSearch.vue?vue&type=template&id=67c0bf08&"
import script from "./ActorSearch.vue?vue&type=script&lang=js&"
export * from "./ActorSearch.vue?vue&type=script&lang=js&"
import style0 from "./ActorSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ActorSearch.vue"
export default component.exports